import { ErrorNumbers } from '@Containers/CasNumber/constants';

export const getKey = (databaseId, substanceId) => `${databaseId}/${substanceId}`;
export const isAPIError = (errorNumber) => errorNumber === ErrorNumbers.CAS_API_UNAVAILABLE;
